var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-col",
    _vm._b(
      {
        directives: [
          {
            name: "hasPermi",
            rawName: "v-hasPermi",
            value: ["merchant:statistics:home:product:pay:ranking"],
            expression: "['merchant:statistics:home:product:pay:ranking']",
          },
        ],
        staticClass: "ivu-mb",
      },
      "el-col",
      _vm.grid,
      false
    ),
    [
      _c(
        "el-card",
        { staticClass: "box-card", staticStyle: { "margin-left": "20px" } },
        [
          _c("div", { staticClass: "header_title" }, [_vm._v("商品支付排行")]),
          _vm._v(" "),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%", padding: "20px" },
              attrs: { data: _vm.payData },
            },
            [
              _c("el-table-column", {
                attrs: { type: "index", label: "排名", width: "60" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            staticClass: "index_common",
                            class: [
                              scope.$index + 1 == "1"
                                ? "index_one"
                                : scope.$index + 1 == "2"
                                ? "index_two"
                                : scope.$index + 1 == "3"
                                ? "index_three"
                                : "index_more",
                            ],
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(scope.$index + 1) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "商品信息", "min-width": "320" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "product_info" }, [
                          _c(
                            "div",
                            { staticClass: "demo-image__preview" },
                            [
                              scope.row.image
                                ? _c("el-image", {
                                    staticClass: "img",
                                    staticStyle: {
                                      width: "36px",
                                      height: "36px",
                                    },
                                    attrs: {
                                      src: scope.row.image,
                                      "preview-src-list": [scope.row.image],
                                    },
                                  })
                                : _c("img", {
                                    staticClass: "img",
                                    staticStyle: {
                                      width: "36px",
                                      height: "36px",
                                    },
                                    attrs: { src: _vm.defaultImg, alt: "" },
                                  }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "m-l-10 line1" }, [
                            _vm._v(_vm._s(scope.row.proName)),
                          ]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "salesAmount", label: "支付金额" },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }